import { render, staticRenderFns } from "./DetailConfig1.vue?vue&type=template&id=bcac8e60&lang=pug&"
import script from "./DetailConfig1.vue?vue&type=script&lang=js&"
export * from "./DetailConfig1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports